module.exports = __webpack_public_path__ + "assets/2eeeb0e2a4eb4e758171b44c1a0401ab.svg";